module.exports = __webpack_public_path__ + "media/npc_dota_hero_phantom_assassin.55e4f23b.webm";